import React from 'react';
import useLocalStorage from '../../hooks/useLocalStorage/useLocalStorage.js';
import { RippleButton } from '../RippleButton/RippleButton.js';
import styles from './CookieBanner.module.css.js';

var origin = typeof window !== 'undefined' ? window.location.host : '';
var CookieBanner = function CookieBanner(_a) {
  var className = _a.className,
      onClickPrivacyPolicy = _a.onClickPrivacyPolicy,
      onClickCookiePolicy = _a.onClickCookiePolicy;

  var _b = useLocalStorage('cookiesAccepted', 'false'),
      localStorageCookiesAccepted = _b[0],
      setLocalStorageCookiesAccepted = _b[1];

  if (localStorageCookiesAccepted === 'true') return /*#__PURE__*/React.createElement("div", null);
  return /*#__PURE__*/React.createElement("div", {
    className: [styles['cookie-banner-wrapper'], className].join(' ')
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "Notice: "), origin, " uses cookies to provide necessary website functionality, improve your experience and analyze our traffic. By using our website, you agree to our", ' ', /*#__PURE__*/React.createElement("button", {
    className: styles['link-wrapper'],
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      onClickPrivacyPolicy();
    }
  }, "Privacy Policy"), ' ', "and our", ' ', /*#__PURE__*/React.createElement("button", {
    className: styles['link-wrapper'],
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      onClickCookiePolicy();
    }
  }, "Cookies Policy"), "."), /*#__PURE__*/React.createElement(RippleButton, {
    onClick: function onClick() {
      return setLocalStorageCookiesAccepted('true');
    },
    size: "small",
    label: "Ok"
  }));
};

export { CookieBanner };
//# sourceMappingURL=CookieBanner.js.map
